import { IonContent, IonIcon } from '@ionic/react';
import { add, home, notificationsOutline, peopleOutline, personOutline, shieldCheckmarkOutline } from 'ionicons/icons';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { demoOrganization } from '../data/demo';
import { useAuth } from '../auth/AuthContext';
import { BrandMark } from './BrandMark';

const navItems = [
  { path: '/inicio', label: 'Inicio', icon: home },
  { path: '/comunidades', label: 'Comunidades', icon: peopleOutline },
  { path: '/avisos', label: 'Avisos', icon: notificationsOutline },
  { path: '/perfil', label: 'Perfil', icon: personOutline },
];

export function AppShell() {
  const { organization, profile, membership } = useAuth();
  const location = useLocation();
  const canManageMembers = membership?.role === 'owner' || membership?.role === 'admin';
  const visibleNavItems = canManageMembers
    ? [...navItems.slice(0, 2), { path: '/miembros', label: 'Miembros', icon: peopleOutline }, ...navItems.slice(2)]
    : navItems;
  const isUtilityPage = location.pathname === '/seguridad' || location.pathname === '/familia' || location.pathname === '/miembros';
  const currentOrganization = organization ?? demoOrganization;
  const initials = (profile?.display_name ?? 'Mi perfil')
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0])
    .join('')
    .toUpperCase();

  return (
    <div
      className="app-shell"
      style={{
        '--brand-primary': currentOrganization.theme.primary,
        '--brand-accent': currentOrganization.theme.accent,
        '--brand-surface': currentOrganization.theme.surface,
      } as React.CSSProperties}
    >
      <header className="topbar">
        <BrandMark organization={currentOrganization} />
        <div className="topbar__actions">
          <NavLink className="icon-button" to="/seguridad" aria-label="Centro de seguridad">
            <IonIcon icon={shieldCheckmarkOutline} />
          </NavLink>
          <NavLink className="avatar avatar--small" to="/perfil" aria-label="Abrir perfil">{initials}</NavLink>
        </div>
      </header>

      <IonContent className="main-content" fullscreen>
        <main className="page-wrap">
          <Outlet />
        </main>
      </IonContent>

      {!isUtilityPage && (
        <>
          <NavLink className="compose-fab" to="/inicio?crear=1" aria-label="Crear publicación">
            <IonIcon icon={add} />
            <span>Publicar</span>
          </NavLink>
          <nav className="bottom-nav" aria-label="Navegación principal" style={{ '--nav-count': visibleNavItems.length } as React.CSSProperties}>
            {visibleNavItems.map((item) => (
              <NavLink key={item.path} to={item.path} className={({ isActive }) => isActive ? 'bottom-nav__item is-active' : 'bottom-nav__item'}>
                <IonIcon icon={item.icon} />
                <span>{item.label}</span>
              </NavLink>
            ))}
          </nav>
        </>
      )}
    </div>
  );
}
